/**
 * Format a percentage value that is already expressed as a percentage (e.g., 1.81 means 1.81%).
 * Backend _pct fields and win_rate are already multiplied by 100.
 */
export const formatPercent = (value: number | undefined | null, decimals = 2): string => {
  if (value === undefined || value === null) return '-';
  return `${value.toFixed(decimals)}%`;
};

export const formatCurrency = (value: number | undefined | null): string => {
  if (value === undefined || value === null) return '-';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  }).format(value);
};
